var _g, _rect, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGotoTask({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 176,
    height: 48,
    viewBox: "0 0 176 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_359_2498)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 48,
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 42,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 6,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 6 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 0 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 158,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 158 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 42,
    width: 6,
    height: 6,
    transform: "rotate(-90 164 42)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 6,
    width: 6,
    height: 6,
    transform: "rotate(-90 170 6)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 164,
    y: 12,
    width: 6,
    height: 6,
    transform: "rotate(-90 164 12)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 170,
    y: 48,
    width: 6,
    height: 6,
    transform: "rotate(-90 170 48)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M52.72 31.18C49.2 31.18 47.2 29.02 47.2 25.2V22.8C47.2 18.98 49.2 16.82 52.72 16.82C56.06 16.82 57.92 18.8 58.16 21.86H56.34C56.12 19.92 55.18 18.52 52.72 18.52C50.02 18.52 49 20.18 49 22.8V25.2C49 27.82 50.02 29.48 52.72 29.48C54.92 29.48 56.4 28.46 56.4 25.14V25.04H52.7V23.44H58.2V25.04C58.2 28.68 56.48 31.18 52.72 31.18ZM59.1984 24.88C59.1984 22.16 60.8584 20.6 63.4184 20.6C65.9784 20.6 67.6184 22.16 67.6184 24.88V26.9C67.6184 29.62 65.9784 31.18 63.4184 31.18C60.8584 31.18 59.1984 29.62 59.1984 26.9V24.88ZM60.8984 26.9C60.8984 28.98 61.9384 29.58 63.4184 29.58C64.8984 29.58 65.9184 28.98 65.9184 26.9V24.88C65.9184 23 64.8984 22.2 63.4184 22.2C61.9384 22.2 60.8984 23 60.8984 24.88V26.9ZM76.2677 31C74.2477 31 73.5477 29.86 73.5477 28.46V22.38H72.0477V20.78H73.5877V18.5H75.2477V20.78H77.7477V22.38H75.2477V29.4H77.7877V31H76.2677ZM78.4891 24.88C78.4891 22.16 80.1491 20.6 82.7091 20.6C85.2691 20.6 86.9091 22.16 86.9091 24.88V26.9C86.9091 29.62 85.2691 31.18 82.7091 31.18C80.1491 31.18 78.4891 29.62 78.4891 26.9V24.88ZM80.1891 26.9C80.1891 28.98 81.2291 29.58 82.7091 29.58C84.1891 29.58 85.2091 28.98 85.2091 26.9V24.88C85.2091 23 84.1891 22.2 82.7091 22.2C81.2291 22.2 80.1891 23 80.1891 24.88V26.9ZM95.3583 31V18.66H91.2383V17H101.278V18.66H97.1583V31H95.3583ZM104.382 31.18C101.822 31.18 100.182 29.62 100.182 26.9V24.88C100.182 22.16 101.822 20.6 104.382 20.6C105.402 20.6 106.262 20.9 106.902 21.46V20.78H108.602V31H106.902V30.32C106.262 30.88 105.402 31.18 104.382 31.18ZM101.882 26.9C101.882 28.98 102.902 29.58 104.382 29.58C105.762 29.58 106.902 28.98 106.902 26.9V24.88C106.902 23 105.762 22.2 104.382 22.2C102.902 22.2 101.882 23 101.882 24.88V26.9ZM114.178 31.18C111.758 31.18 110.058 30 109.998 27.62H111.678C111.678 28.98 112.718 29.58 114.178 29.58C115.658 29.58 116.518 28.96 116.518 28.1C116.518 27.48 116.078 27.04 115.158 26.8L112.758 26.2C111.298 25.84 110.418 24.94 110.418 23.48C110.418 21.86 111.738 20.6 114.078 20.6C116.398 20.6 117.978 21.96 117.978 23.9H116.338C116.278 22.7 115.358 22.14 114.078 22.14C112.718 22.14 112.038 22.74 112.038 23.48C112.038 24.24 112.618 24.5 113.338 24.68L115.518 25.22C117.258 25.66 118.218 26.54 118.218 28.1C118.218 29.86 116.718 31.18 114.178 31.18ZM127.792 20.98L121.992 25.48L127.912 30.8V31H125.712L121.492 27.22V31H119.812V16.2H121.492V23.88L125.432 20.78H127.792V20.98Z",
    fill: "#F5F5F5"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.25,
    y: 0.25,
    width: 175.5,
    height: 47.5,
    stroke: "black",
    strokeWidth: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_359_2498"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 176,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGotoTask);
export default __webpack_public_path__ + "static/media/goto_task.c2af7fa11d19464fee3775ac21fc1268.svg";
export { ForwardRef as ReactComponent };